<template>
	<v-tooltip
			v-bind="position"
			open-delay="1"
			:content-class="`tooltipContent ${contentClass}`"
	>
		<template v-slot:activator="{ on, attrs }">
        <span :style="{ margin }" class="tooltipDropDown" :class="customClass" v-bind="attrs" v-on="on">
             <slot></slot>
        </span>
		</template>
		<span>{{ text }}</span>
	</v-tooltip>
</template>

<script>
export default {
	name: "ToolTip",
	props: {
		margin: String,
		text: String,
		customClass: String,
		contentClass: {
			type: String,
			default: "noArrow"
		},
		position: {
			type: Object,
			default: () => ({ left: 'left' })
		},
	}
};
</script>

<style lang="scss">
.tooltipDropDown {
	line-height: 1;
	display: inline-block;
	&.question {
		display: block;
		margin-left: 0;
		svg {
			display: block;
		}
	}
}

.tooltipContent {
	font-weight: 500;
	font-size: 14px;
	line-height: 20px;
	background: #1C1C28;

	&:not(.noArrow):after {
		content: '';
		width: 12px;
		height: 12px;
		background: #1C1C28;
		position: absolute;
		border-radius: 0 0 0 2px;
		transform: matrix(0.7, -0.7, 0.74, 0.7, 0, 0);
	}

	&.top:after {
		bottom: -6px;
		left: calc(50% - 6px);
	}

	&.bottom:after {
		top: -6px;
		left: calc(50% - 6px);
	}

	&.right:after {
		bottom: calc(50% - 6px);
		left: -6px;
	}

	&.left:after {
		bottom: calc(50% - 6px);
		right: -6px;
	}
}

</style>
